import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { InceptionService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-accordion-panel',
  templateUrl: './accordion-panel.component.html',
})
export class AccordionPanelComponent implements OnInit {
  @Input() title: string;
  @Input() dataCyTitle?: string;
  @Input() dataCySelector?: string;
  @Input() expanded?: boolean = false;
  // used for the html template to keep the animations of the accordion
  isExpanded: boolean;

  constructor(
    private inceptionService: InceptionService,
    private elementRef: ElementRef,
  ) {}

  ngOnInit(): void {
    this.isExpanded = this.expanded;
    if (this.isExpanded) {
      this.elementRef.nativeElement.firstChild.firstChild.setAttribute(
        'data-expanded',
        '',
      );
    }
    setTimeout(() => {
      this.inceptionService.panelAccordion(this.elementRef);
      this.inceptionService.init();
    });
  }
}
